import { checkoutReviewAndSubmitPaymentDetailsStyles as styles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.paymentDetailsHeading = {
    ...styles.paymentDetailsHeading,
    variant: "h3",
    css: css`
        ${styles.paymentDetailsHeading?.css}
        padding: 0 0 10px 0;
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
        margin-bottom: 10px;
    `,
};
